<wbo-bi-items-container [title]="title">
    <wbo-bi-draggable-item *ngFor="let attribute of attributes" [data]="attribute" [dropZones]="attribute.types"
                           [label]="attribute.label" [icon]="attribute.icon "></wbo-bi-draggable-item>
</wbo-bi-items-container>
